import * as React from 'react';
const h = React.createElement;

export interface TitleProps extends React.HTMLAttributes<HTMLHeadingElement> {
  level?: 1 | 2 | 3 | 4 | 5;
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

const Title: React.FC<TitleProps> = function Title(props) {
  const { level = 1, children, className = '', style, ...rest } = props;
  const tag = `h${Math.min(level, 5)}` as 'h1' | 'h2' | 'h3' | 'h4' | 'h5';
  const sizeClass: string =
    (
      {
        1: 'text-3xl',
        2: 'text-2xl',
        3: 'text-xl',
        4: 'text-lg',
        5: 'text-base',
      } as Record<number, string>
    )[level] || 'text-3xl';

  return h(
    tag,
    {
      className: `font-bold text-white ${sizeClass} ${className}`,
      style: style || {},
      ...rest,
    },
    children,
  );
};

export type TextType = 'secondary' | 'success' | 'warning' | 'danger';

export interface TextProps extends React.HTMLAttributes<HTMLSpanElement> {
  type?: TextType;
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

const Text: React.FC<TextProps> = function Text(props) {
  const { type, children, className = '', style, ...rest } = props;
  const typeMap: Record<TextType, string> = {
    secondary: 'text-dark-400',
    success: 'text-green-400',
    warning: 'text-yellow-400',
    danger: 'text-red-400',
  };
  const typeClass = (type && typeMap[type]) || 'text-dark-200';

  return h(
    'span',
    {
      className: `${typeClass} ${className}`,
      style: style || {},
      ...rest,
    },
    children,
  );
};

export interface ParagraphProps extends React.HTMLAttributes<HTMLParagraphElement> {
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

const Paragraph: React.FC<ParagraphProps> = function Paragraph(props) {
  const { children, className = '', style, ...rest } = props;
  return h(
    'p',
    {
      className: `text-sm text-dark-300 leading-relaxed ${className}`,
      style: style || {},
      ...rest,
    },
    children,
  );
};

const Typography = { Title, Text, Paragraph };

export { Typography };
